/**
 * created by lei lei
 * 发布设置信息
 */
import React, {Component} from 'react';
import './EditorPublishInformation.css'
export default class EditorPublishInformation extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    getData=()=>{
        let {modules} = this.props.informationConfig;
        let data={};
        if(modules && modules.length) {
            modules.forEach(module=>{
                let key = module;
                if(module.prototype instanceof Component){
                    let CustomModule = module;
                    key = CustomModule.prototype.constructor.name;
                }

                if(this[key] && typeof this[key].getData == 'function') {
                    data[key] = this[key].getData()
                } else {
                    data[key] = {}
                }
            })
        }
        return data
    };

    getDetails = () => {
        let {modules} = this.props.informationConfig;
        let data={};
        if(modules && modules.length) {
            modules.forEach(module=>{
                let key = module;
                if(module.prototype instanceof Component){
                    let CustomModule = module;
                    key = CustomModule.prototype.constructor.name;
                }

                if(this[key] && typeof this[key].getDetails == 'function') {
                    data[key] = this[key].getDetails()
                } else {
                    data[key] = {}
                }
            })
        }
        return data
    };

    setData=(data)=>{
        if(data) {
            let {modules} = this.props.informationConfig;
            if(modules && modules.length) {
                modules.forEach(module=>{
                    let key = module;
                    if(module.prototype instanceof Component){
                        let CustomModule = module;
                        key = CustomModule.prototype.constructor.name;
                    }
                    let newData = data[key];
                    if(data[key] && this[key] && typeof this[key].setData == 'function') {
                        this[key].setData(newData)
                    }
                })
            }
        }
    };

    render() {
        let {title} = this.props;
        return (
            <div id="publishSetting">
                <div style={{fontSize: 15, fontWeight: 'bold', height: 40}}>
                    <b>{title}</b>
                </div>
                {this.main()}
            </div>
        )
    }

    main = () => {
        let {informationConfig, dynamicParams} = this.props;
        let {modules} = informationConfig;
        return (
            <>
                {modules && modules.length ?
                    (
                        modules.map((module,i) => {
                            if (typeof module == "string") {
                                let publishModule = require(`./publishInItem/${module}`); // 引入编辑器
                                return (
                                    <div key={module}>
                                        {
                                            this.props.isLine === 'noLine' ? '' :
                                                <div className={i > 0 ? "line" : "topLine"}></div>
                                        }
                                        <publishModule.default ref={(ref)=>{this[module]=ref}} dynamicParams={dynamicParams}/>
                                    </div>
                                )
                            }else if(module.prototype instanceof Component){
                                let CustomModule = module;
                                return <CustomModule key={i} ref={(ref)=>{this[CustomModule.prototype.constructor.name]=ref}} dynamicParams={dynamicParams}/>
                            }
                        })
                    )
                    : null}
            </>
        )
    };
}
